(self.webpackChunk_N_E = self.webpackChunk_N_E || []).push([
  [185], {
    6157: function(e, s, l) {
      Promise.resolve().then(l.bind(l, 2287))
    },
    2287: function(e, s, l) {
      "use strict";
      l.r(s), l.d(s, {
        default: function() {
          return h
        }
      });
      var i = l(7437),
        r = l(5540),
        t = l.n(r);
      l(2714), l(7960);
      var o = l(2224),
        n = l.n(o),
        a = l(3755);

      function c(e) {
        let {
          children: s
        } = e;
        return (0, i.jsx)(a.Xu, {
          children: s
        })
      }

      function h(e) {
        let {
          children: s
        } = e;
        return (0, i.jsx)("html", {
          lang: "en",
          children: (0, i.jsx)("body", {
            className: `${n().wrapper} ${t().className}`,
            children: (0, i.jsxs)(c, {
              children: [(0, i.jsx)("title", {
                children: window.pageTitle
              }), (0, i.jsx)("link", {
                rel: "shortcut icon",
                href: window.assetsPath + "tm7-landing-favicon.ico"
              }), s, (0, i.jsxs)("footer", {
                className: "footer",
                children: [(0, i.jsx)("div", {
                    dangerouslySetInnerHTML: { __html: window.footer.some_html_content }
                  }), (0, i.jsxs)("div", {
                  className: "footer__page-width",
                  children: [(0, i.jsx)("img", {
                    className: "footer__logo",
                    src: window.footer.logo_image_url,
                    alt: "Vorwerk Hellas",
                    width: "150",
                    height: "57.5"
                  }), (0, i.jsxs)("div", {
                    className: "footer__menu-list",
                    children: [(0, i.jsxs)("div", {
                      className: "footer__menu-list-item",
                      children: [(0, i.jsx)("h2", {
                        className: "footer__menu-title",
                        children: window.footer.item_1_title
                      }), (0, i.jsxs)("div", {
                        className: "footer__menu-rte",
                        children: [(0, i.jsxs)("p", {
                          children: [window.footer.item_1_email_text + " ", (0, i.jsx)("a", {
                            href: "mailto:" + window.footer.item_1_email_address,
                            target: "_blank",
                            title: "mailto:" + window.footer.item_1_email_address,
                            rel: "noreferrer noopener",
                            children: window.footer.item_1_email_address
                          })]
                        }), (0, i.jsx)("p", {
                          children: window.footer.item_1_phone_text
                        })]
                      })]
                    }), (0, i.jsxs)("div", {
                      className: "footer__menu-list-item",
                      children: [(0, i.jsx)("h2", {
                        className: "footer__menu-title",
                        children: window.footer.item_2_title
                      }), (0, i.jsxs)("ul", {
                        className: "footer__menu-links-list",
                        children: [(0, i.jsx)("li", {
                          className: "footer__menu-links-list-item",
                          children: (0, i.jsx)("a", {
                            href: window.footer.item_2_url_1,
                            children: window.footer.item_2_text_1,
                          })
                        }), (0, i.jsx)("li", {
                          className: "footer__menu-links-list-item",
                          children: (0, i.jsx)("a", {
                            href: window.footer.item_2_url_2,
                            children: window.footer.item_2_text_2,
                          })
                        }), (0, i.jsx)("li", {
                          className: "footer__menu-links-list-item",
                          children: (0, i.jsx)("a", {
                            href: window.footer.item_2_url_3,
                            children: window.footer.item_2_text_3,
                          })
                        }), (0, i.jsx)("li", {
                          className: "footer__menu-links-list-item",
                          children: (0, i.jsx)("a", {
                            href: window.footer.item_2_url_4,
                            children: window.footer.item_2_text_4,
                          })
                        })]
                      })]
                    }), (0, i.jsxs)("div", {
                      className: "footer__menu-list-item",
                      children: [(0, i.jsx)("h2", {
                        className: "footer__menu-title",
                        children: window.footer.item_3_title,
                      }), (0, i.jsxs)("ul", {
                        className: "footer__social-list",
                        children: [(0, i.jsx)("li", {
                          className: "footer__social-list-item",
                          children: (0, i.jsxs)("a", {
                            target: "_blank",
                            href: window.footer.item_3_url_1,
                            rel: "noreferrer noopener",
                            children: [(0, i.jsxs)("svg", {
                              width: "40",
                              height: "41",
                              viewBox: "0 0 40 41",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                              children: [" ", (0, i.jsxs)("g", {
                                clipPath: "url(#clip0_6239_54143)",
                                children: [" ", (0, i.jsx)("path", {
                                  d: "M36 20.2599C36 11.4232 28.8367 4.25995 20 4.25995C11.1633 4.25995 4 11.4232 4 20.2599C4 28.2457 9.85007 34.8662 17.4993 36.0656V24.8845H13.4364V20.2599H17.4993V16.7352C17.4993 12.7245 19.8886 10.5106 23.5437 10.5106C25.2954 10.5106 27.1253 10.8235 27.1253 10.8235V14.7607H25.1081C23.1218 14.7607 22.5007 15.9933 22.5007 17.2591V20.2599H26.9381L26.2293 24.8845H22.5007V36.0656C30.1499 34.8662 36 28.2457 36 20.2599Z",
                                  fill: "white"
                                }), " "]
                              }), " ", (0, i.jsxs)("defs", {
                                children: [" ", (0, i.jsxs)("clipPath", {
                                  id: "clip0_6239_54143",
                                  children: [" ", (0, i.jsx)("rect", {
                                    width: "32",
                                    height: "32",
                                    fill: "white",
                                    transform: "translate(4 4.25995)"
                                  }), " "]
                                }), " "]
                              }), " "]
                            }), (0, i.jsx)("span", {
                              className: "footer__visually-hidden",
                              children: "Facebook"
                            })]
                          })
                        }), (0, i.jsx)("li", {
                          className: "footer__social-list-item",
                          children: (0, i.jsxs)("a", {
                            target: "_blank",
                            href: window.footer.item_3_url_2,
                            rel: "noreferrer noopener",
                            children: [(0, i.jsxs)("svg", {
                              width: "40",
                              height: "41",
                              viewBox: "0 0 40 41",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                              children: [" ", (0, i.jsxs)("g", {
                                clipPath: "url(#clip0_6239_54145)",
                                children: [" ", (0, i.jsxs)("mask", {
                                  id: "mask0_6239_54145",
                                  maskUnits: "userSpaceOnUse",
                                  x: "4",
                                  y: "4",
                                  width: "32",
                                  height: "33",
                                  children: [" ", (0, i.jsx)("path", {
                                    d: "M20 36.2599C28.8366 36.2599 36 29.0965 36 20.2599C36 11.4234 28.8366 4.25995 20 4.25995C11.1634 4.25995 4 11.4234 4 20.2599C4 29.0965 11.1634 36.2599 20 36.2599Z",
                                    fill: "white"
                                  }), " "]
                                }), " ", (0, i.jsxs)("g", {
                                  mask: "url(#mask0_6239_54145)",
                                  children: [" ", (0, i.jsx)("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M10.992 4.29835C11.3719 4.26699 13.3255 4.25995 20.0052 4.25995H25.2122C28.9654 4.26623 29.1788 4.29716 29.8919 4.40053L29.9332 4.40651C31.4759 4.62891 32.7703 5.24459 33.8288 6.25579C34.4221 6.82667 34.8304 7.38507 35.1984 8.13259C35.6468 9.04587 35.8672 9.90987 35.968 11.195C35.9895 11.4708 35.9994 15.8593 35.9994 20.2494C35.9994 24.6395 35.9904 29.0353 35.9687 29.3111C35.8692 30.5755 35.6487 31.4471 35.2144 32.3431C34.3508 34.1255 32.7632 35.4254 30.8461 35.9201C30.1508 36.1 29.522 36.1844 28.4391 36.2353C28.0528 36.2551 24.0116 36.2599 19.9706 36.2599C15.9296 36.2599 11.8909 36.2478 11.4948 36.2305C10.5597 36.186 9.83108 36.0926 9.17156 35.9227C7.26692 35.4302 5.64996 34.1108 4.80324 32.3531C4.36036 31.435 4.15108 30.5956 4.04036 29.2612C4.00836 28.882 4.001 26.9297 4.001 20.2535C4.001 19.4356 4.0007 18.6933 4.00043 18.0186C3.99996 16.8379 3.99957 15.8641 4.001 15.0532C4.00729 11.2963 4.03799 11.0842 4.14172 10.3678C4.14354 10.3553 4.14537 10.3426 4.14724 10.3297C4.36996 8.78795 4.98532 7.49131 6.00036 6.43723C6.5578 5.85899 7.1226 5.44683 7.83876 5.09099C8.76836 4.62827 9.62116 4.41227 10.992 4.29835ZM15.7786 10.0817C16.8711 10.0321 17.2199 10.0199 20.001 10.0199V10.0196C22.7798 10.0196 23.1278 10.0318 24.2196 10.0814C25.3095 10.1313 26.0541 10.3041 26.7069 10.5572C27.3812 10.8187 27.9508 11.1684 28.5204 11.738C29.09 12.3073 29.4397 12.8785 29.7021 13.5521C29.954 14.2033 30.1268 14.9473 30.178 16.0375C30.2269 17.13 30.2397 17.4788 30.2397 20.2599C30.2397 23.0411 30.2269 23.3892 30.178 24.4814C30.1268 25.5713 29.954 26.3156 29.7021 26.9668C29.4397 27.6401 29.09 28.2113 28.5204 28.7806C27.9514 29.3502 27.3808 29.7009 26.7076 29.9623C26.056 30.2158 25.3111 30.3883 24.2208 30.4382C23.1287 30.4878 22.7802 30.4999 19.9994 30.4999C17.2186 30.4999 16.8698 30.4878 15.7776 30.4382C14.6877 30.3883 13.9434 30.2155 13.2919 29.9623C12.6186 29.7009 12.0474 29.3502 11.4784 28.7806C10.9088 28.2113 10.5591 27.6401 10.2973 26.9665C10.0442 26.3153 9.87172 25.5713 9.82148 24.4811C9.7722 23.3889 9.75972 23.0407 9.75972 20.2599C9.75972 17.4791 9.77252 17.1297 9.82148 16.0375C9.87076 14.9476 10.0436 14.2033 10.2973 13.5521C10.5597 12.8788 10.9095 12.3076 11.4791 11.7383C12.0484 11.1691 12.6196 10.819 13.2932 10.5575C13.9444 10.3041 14.6884 10.1316 15.7786 10.0817ZM19.6597 11.8653C19.4526 11.8652 19.2606 11.8652 19.0823 11.8654V11.8631C17.1738 11.8654 16.8077 11.8782 15.8631 11.9207C14.8647 11.9665 14.3226 12.1329 13.9616 12.2737C13.4839 12.4599 13.1424 12.6817 12.784 13.0401C12.4256 13.3985 12.2032 13.7399 12.0176 14.2177C11.8775 14.5787 11.7108 15.1204 11.665 16.1188C11.616 17.1985 11.6061 17.5211 11.6061 20.2555C11.6061 22.9899 11.616 23.3143 11.665 24.3937C11.7104 25.3921 11.8775 25.9339 12.0176 26.2945C12.2039 26.7726 12.4256 27.1131 12.784 27.4715C13.1424 27.8299 13.4839 28.0516 13.9616 28.2372C14.3229 28.3774 14.8647 28.5441 15.8631 28.5902C16.9428 28.6395 17.2669 28.65 20.001 28.65C22.7351 28.65 23.0596 28.6391 24.1389 28.5902C25.1373 28.5444 25.6794 28.378 26.04 28.2372C26.5181 28.0516 26.8583 27.8299 27.2167 27.4715C27.5751 27.1134 27.7975 26.7729 27.9831 26.2951C28.1232 25.9345 28.29 25.3927 28.3357 24.3943C28.385 23.3147 28.3956 22.9905 28.3956 20.2577C28.3956 17.5249 28.3847 17.2004 28.3357 16.1211C28.2903 15.1227 28.1232 14.5809 27.9831 14.2203C27.7968 13.7425 27.5751 13.4011 27.2167 13.0427C26.8586 12.6843 26.5178 12.4625 26.04 12.2769C25.6791 12.1367 25.1373 11.97 24.1389 11.9243C23.0592 11.8753 22.7351 11.8654 20.001 11.8654C19.8828 11.8654 19.7691 11.8654 19.6597 11.8653ZM24.2381 14.794C24.2381 14.1153 24.7885 13.5655 25.4669 13.5655V13.5652C26.1453 13.5652 26.6957 14.1156 26.6957 14.794C26.6957 15.4724 26.1453 16.0228 25.4669 16.0228C24.7885 16.0228 24.2381 15.4727 24.2381 14.794ZM14.7421 20.2603C14.7421 17.3563 17.0967 15.0017 20.0007 15.0017C22.9047 15.0017 25.2586 17.3563 25.2586 20.2603C25.2586 23.1643 22.9047 25.5179 20.0007 25.5179C17.0967 25.5179 14.7421 23.1643 14.7421 20.2603ZM23.4141 20.2606C23.4141 18.3751 21.8858 16.8471 20.0007 16.8471C18.1152 16.8471 16.5872 18.3755 16.5872 20.2606C16.5872 22.1457 18.1156 23.674 20.0007 23.674C21.8858 23.674 23.4141 22.146 23.4141 20.2606Z",
                                    fill: "white"
                                  }), " "]
                                }), " "]
                              }), " ", (0, i.jsxs)("defs", {
                                children: [" ", (0, i.jsxs)("clipPath", {
                                  id: "clip0_6239_54145",
                                  children: [" ", (0, i.jsx)("rect", {
                                    width: "32",
                                    height: "32",
                                    fill: "white",
                                    transform: "translate(4 4.25995)"
                                  }), " "]
                                }), " "]
                              }), " "]
                            }), (0, i.jsx)("span", {
                              className: "footer__visually-hidden",
                              children: "Instagram"
                            })]
                          })
                        }), (0, i.jsx)("li", {
                          className: "footer__social-list-item",
                          children: (0, i.jsxs)("a", {
                            target: "_blank",
                            href: window.footer.item_3_url_3,
                            rel: "noreferrer noopener",
                            children: [(0, i.jsx)("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              children: (0, i.jsx)("path", {
                                fill: "#fff",
                                d: "M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2 16h-2v-6h2v6zm-1-6.891c-.607 0-1.1-.496-1.1-1.109 0-.612.492-1.109 1.1-1.109s1.1.497 1.1 1.109c0 .613-.493 1.109-1.1 1.109zm8 6.891h-1.998v-2.861c0-1.881-2.002-1.722-2.002 0v2.861h-2v-6h2v1.093c.872-1.616 4-1.736 4 1.548v3.359z"
                              })
                            }), (0, i.jsx)("span", {
                              className: "footer__visually-hidden",
                              children: "LinkedIn"
                            })]
                          })
                        })]
                      })]
                    }), (0, i.jsxs)("div", {
                      className: "footer__menu-list-item",
                      children: [(0, i.jsx)("h2", {
                        className: "footer__menu-title",
                        children: window.footer.item_4_title
                      }), (0, i.jsxs)("div", {
                        className: "footer__country-selector",
                        children: [(0, i.jsxs)("select", {
                          className: "footer__country-selector-input",
                          onChange: e => location = e.target.value,
                          children: [(0, i.jsx)("option", {
                            value: "#",
                            children: "Greece"
                          }), (0, i.jsx)("option", {
                            value: "https://www.vorwerk.com/de/de/c/home",
                            children: "Germany"
                          }), (0, i.jsx)("option", {
                            value: "https://www.vorwerk.com/fr/fr/c/home",
                            children: "France"
                          }), (0, i.jsx)("option", {
                            value: "https://www.vorwerk.com/es/es/c/home",
                            children: "Spain"
                          }), (0, i.jsx)("option", {
                            value: "https://www.vorwerk.com/it/it/c/home",
                            children: "Italy"
                          }), (0, i.jsx)("option", {
                            value: "https://www.vorwerk.com/at/de/c/home",
                            children: "Austria"
                          }), (0, i.jsx)("option", {
                            value: "https://www.thermomix.ca/",
                            children: "Canada"
                          }), (0, i.jsx)("option", {
                            value: "https://thermomix.vorwerk.com.cn/",
                            children: "China(Thermomix)"
                          }), (0, i.jsx)("option", {
                            value: "https://www.vorwerk.com.cn/",
                            children: "China(Kobold)"
                          }), (0, i.jsx)("option", {
                            value: "https://www.vorwerk.cz/",
                            children: "Czech Republic"
                          }), (0, i.jsx)("option", {
                            value: "https://www.thermomix.mx/",
                            children: "Mexico"
                          }), (0, i.jsx)("option", {
                            value: "https://www.vorwerk.com/pl/pl/c/strona-glowna",
                            children: "Poland"
                          }), (0, i.jsx)("option", {
                            value: "https://www.vorwerk.com/pt/pt/c/home/",
                            children: "Portugal"
                          }), (0, i.jsx)("option", {
                            value: "https://vorwerk.ch/",
                            children: "Switzerland"
                          }), (0, i.jsx)("option", {
                            value: "https://vorwerk.com.tw/",
                            children: "Taiwan"
                          }), (0, i.jsx)("option", {
                            value: "https://thermomix.vorwerk.com.tr/tr/c/home",
                            children: "Turkey"
                          }), (0, i.jsx)("option", {
                            value: "https://www.vorwerk.co.uk/en/c/home",
                            children: "United Kingdom"
                          }), (0, i.jsx)("option", {
                            value: "https://www.thermomix.com/",
                            children: "USA"
                          }), (0, i.jsx)("option", {
                            value: "https://thermomix.com.au/",
                            children: "Australia"
                          })]
                        }), (0, i.jsxs)("svg", {
                          width: "20",
                          height: "20",
                          viewBox: "0 0 20 20",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                          children: [" ", (0, i.jsxs)("g", {
                            id: "language",
                            children: [" ", (0, i.jsx)("path", {
                              id: "vector",
                              fillRule: "evenodd",
                              clipRule: "evenodd",
                              d: "M2.5 10.0005C2.5 5.85882 5.85833 2.50049 10 2.50049C14.1417 2.50049 17.5 5.85882 17.5 10.0005C17.5 14.1422 14.1417 17.5005 10 17.5005C5.85833 17.5005 2.5 14.1422 2.5 10.0005ZM4.21667 8.40049C4.075 8.90882 4 9.44215 4 10.0005C4 10.5588 4.075 11.0922 4.21667 11.6005H6.69167C6.63333 11.0755 6.6 10.5422 6.6 10.0005C6.6 9.45882 6.63333 8.92549 6.69167 8.40049H4.21667ZM4.85833 6.90049H6.93333C7.125 6.02549 7.39167 5.20049 7.725 4.44215C6.525 4.93382 5.525 5.80049 4.85833 6.90049ZM9.63333 4.00882C9.14167 4.81715 8.74167 5.80882 8.475 6.90049H11.5083C11.2333 5.80882 10.8333 4.81715 10.3417 4.00882C10.225 4.00882 10.1083 4.00049 9.99167 4.00049C9.86667 4.00049 9.75 4.00049 9.625 4.00882H9.63333ZM12.2583 4.43382C12.5917 5.19216 12.8667 6.02549 13.0583 6.90049H15.1417C14.475 5.80049 13.4667 4.92549 12.2583 4.43382ZM15.7917 8.40049H13.3083C13.3667 8.92549 13.4 9.45882 13.4 10.0005C13.4 10.5422 13.3667 11.0755 13.3083 11.6005H15.7917C15.9333 11.0922 16.0083 10.5588 16.0083 10.0005C16.0083 9.44215 15.9333 8.90882 15.7917 8.40049ZM15.15 13.1005H13.0667C12.875 13.9755 12.6 14.8088 12.2667 15.5672C13.475 15.0755 14.4833 14.2088 15.15 13.1005ZM10.3583 15.9922C10.85 15.1838 11.25 14.1922 11.525 13.1005H8.48333C8.75 14.1922 9.15 15.1838 9.63333 15.9922C9.75833 15.9922 9.88333 16.0005 10 16.0005C10.1167 16.0005 10.2333 16.0005 10.35 15.9922H10.3583ZM7.73333 15.5588C7.4 14.8005 7.13333 13.9755 6.95 13.1005H4.875C5.53333 14.1922 6.54167 15.0672 7.73333 15.5588ZM8.21667 11.6005H11.8083C11.875 11.0755 11.9083 10.5422 11.9083 10.0005C11.9083 9.45882 11.875 8.92549 11.8083 8.40049H8.21667C8.15 8.92549 8.11667 9.45882 8.11667 10.0005C8.11667 10.5422 8.15 11.0755 8.21667 11.6005Z",
                              fill: "#8BDAAB"
                            }), " "]
                          }), " "]
                        })]
                      })]
                    })]
                  })]
                }), (0, i.jsx)("div", {
                  className: "footer__copyright",
                  children: (0, i.jsx)("div", {
                    className: "footer__page-width",
                    children: (0, i.jsx)("small", {
                      className: "footer__copyright-text",
                      children: window.footer.copyright_text
                    })
                  })
                })]
              })]
            })
          })
        })
      }
    },
    7960: function() {},
    2714: function() {},
    2224: function(e) {
      e.exports = {
        wrapper: "layout_wrapper__ZtxRh",
        footerSmallLinks: "layout_footerSmallLinks__y_qT0"
      }
    },
    5540: function(e) {
      e.exports = {
        style: {
          fontFamily: "'__vorwerkFont_643a5b', '__vorwerkFont_Fallback_643a5b', Vorwerk, system-ui, arial"
        },
        className: "__className_643a5b"
      }
    }
  },
  function(e) {
    e.O(0, [983, 108, 755, 971, 117, 744], function() {
      return e(e.s = 6157)
    }), _N_E = e.O()
  }
]);